import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { clazz } from './Header.styles.js';
import { twMerge } from 'tailwind-merge';
import useProps from '../../../../atom/hook/useProps.js';
import clsx from 'clsx';
import '../../../../tailwind.css.js';

var Header = forwardRef(function (_props, _ref) {
    var _a = useProps(_props, ['hover', 'border']), props = _a.props, rest = _a.rest;
    return (React.createElement("th", __assign({}, rest, { ref: _ref, align: rest.align || 'left', className: twMerge(clsx(clazz(props), rest.className)) }), React.isValidElement(rest.children) ? rest.children : React.createElement("span", { className: "text-sm leading-4 font-bold text-dark-text" }, rest.children)));
});

export { Header as default };
